import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

import { Interval } from 'app/types';
import Social from 'entity/Social';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private social?: Social;
  private time = new Subject<string>();
  public didReachTargetTime = new BehaviorSubject<boolean>(false);
  private timerInterval?: Interval;

  public startTimer(social: Social): Subject<string> {
    this.social = social;
    this.count();
    return this.time;
  }

  private count() {
    this.timerInterval = setInterval(() => {
      const { endDateTime } = this.social ?? {};
      if (!endDateTime) {
        return;
      }
      const timeLeft = +endDateTime - Date.now();
      const r = this.convert(timeLeft);
      this.time.next(r);
    }, 1000);
  }

  private convert(t: number): string {
    const sec = Math.floor((t / 1000) % 60);
    const min = Math.floor((t / (1000 * 60)) % 60);
    const hour = Math.floor((t / (1000 * 60 * 60)) % 24);

    const h = hour < 10 ? '0' + hour : hour;
    const m = min < 10 ? '0' + min : min;
    const s = sec < 10 ? '0' + sec : sec;

    if (hour === 0 && min <= 10) {
      this.didReachTargetTime.next(true);
    }

    if (hour <= 0 && min <= 0 && sec <= 0) {
      return '00:00:00';
    } else {
      return `${h}:${m}:${s}`;
    }
  }

  /**
   * Test utility for showing the timer
   */
  public showTimer(): void {
    this.didReachTargetTime.next(true);
  }

  public hideTimer(): void {
    this.didReachTargetTime.next(false);
  }

  public destroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    this.timerInterval = undefined;
  }
}
